import React, { useState, useEffect } from 'react';

import { connect } from "react-redux";
import { compose } from "redux";
import { LuPlus } from "react-icons/lu";
import Collapse from '../assets/images/collapse.svg';
import Expand from '../assets/images/uncollapse.svg';
//import AddUp from '../assets/images/addup.svg';
import { LuArrowLeft } from "react-icons/lu";
import { HiOutlineDotsVertical } from "react-icons/hi";


import { setSidebarCollapsed } from "../store/actions/authActions";

import { createDepartment, resetNewlycreatedDepartmentId, getDepartments } from "../store/actions/departmentActions";

import Overlay from "../components/Departments/Overlay";
import NotificationsOverlay from "../components/Departments/NotificationsOverlay";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';

const ITSideBar = (props) => {




    const { sidebar_collapsed, setSidebarCollapsedFN, departments, setActiveDepartment, activeDepartmentId, newlycreatedDepartmentId, resetNewlycreatedDepartmentIdFN, createDepartmentFN, getDepartmentsFN, profile } = props;
    const [collapsed, setCollapsed] = useState(true);

    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [isNotificationsPopupOpen, setIsNotificationsPopupOpen] = useState(false);
    const [currentDepartment, setCurrentDepartment] = useState(null);


    const [departmentfornotifications, setDepartmentfornotifications] = useState(null);


    const closeNotificationsPopup = () => {
        setIsNotificationsPopupOpen(false);
    }

    const closeCreation = () => {
        getDepartmentsFN();
        resetNewlycreatedDepartmentIdFN();
        setIsPopupOpen(false);

    }


    useEffect(() => {
        setCollapsed(sidebar_collapsed);
    }, [sidebar_collapsed]);


    useEffect(() => {
        if (newlycreatedDepartmentId) {
            ////////console.log("newlycreatedDepartmentId", newlycreatedDepartmentId);
            let department = departments && departments.find(department => department.department_id === newlycreatedDepartmentId);
            ////////console.log("department", department);
            resetNewlycreatedDepartmentIdFN();
            setCurrentDepartment(department);
            setIsPopupOpen(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newlycreatedDepartmentId]);

    /*
    
      <button
                                title={department.name}
                                onClick={() => setActiveDepartment(department.department_id)}
                                className={`flex items-center justify-center w-10 h-10 mb-4 rounded-full hover:bg-[#3b3b3b] hover:bg-opacity-20  ${activeDepartmentId === department.department_id ? 'border-2 border-[#26eb81]' : ''}`}
                                style={{ backgroundColor: department.color }}
                            >
                                <span className="text-white font-bold">{department.name.charAt(0).toUpperCase()}</span>
                            </button>
    
                            */

    const [hoveredDepartmentId, setHoveredDepartmentId] = useState(null);

    return (
        <div className={`static ${collapsed ? 'w-0 min-w-0' : 'w-52 min-w-52'} h-full overflow-y-auto scrollbar-hidden transition-width duration-300 p-0 bg-[#F4F4F4]`}>

            <div className="flex flex-col w-full items-center"> {/* Added items-center to center the buttons */}
                {collapsed && <div className={`flex justify-end ${!collapsed ? 'absolute' : ''}`}>
                    <div className={`${collapsed ? 'relative right-0 top-[100px]' : ''}`}>
                        <button onClick={() => setSidebarCollapsedFN(!collapsed)} className={collapsed ? "p-3" : "p-2"}>
                            <img src={collapsed ? Expand : Collapse} alt="Toggle" className="w-7 h-7 hover:opacity-70" />
                        </button>
                    </div>
                </div>}


                {!collapsed && (
                    <div className="flex items-center w-full h-16 border-b border-gray-300">
                        <p className="text-[#3b3b3b] font-bold text-sm flex-grow ml-4">Departments</p>
                        <div className="flex">
                            {profile && (profile.role === "Admin") && <button onClick={() => createDepartmentFN()} className="ml-4 p-0">
                                <LuPlus alt="Toggle" className="w-4 h-4 hover:text-[#3b3b3b]" />
                            </button>}
                            <button onClick={() => setSidebarCollapsedFN(!collapsed)} className="p-2">
                                <LuArrowLeft alt="Toggle" className="w-4 h-4 hover:text-[#3b3b3b]" />
                            </button>
                        </div>
                    </div>
                )}

                <nav className="flex flex-col mb-2 relative">


                    {!collapsed && departments && departments.filter(department => profile.role !== "User" || department.department_id === profile.department_id).map((department) => (
                        <div
                            key={department.department_id}
                            className={`flex items-center justify-between cursor-pointer w-48 hover:bg-white hover:bg-opacity-100 w-50 hover:rounded hover:shadow-lg m-2 ${activeDepartmentId === department.department_id ? 'bg-white rounded shadow-lg' : ''}`}
                            onMouseEnter={() => setHoveredDepartmentId(department.department_id)}
                            onMouseLeave={() => setHoveredDepartmentId(null)}
                        >
                            <div
                                className="flex items-center flex-grow"
                                onClick={() => setActiveDepartment(department.department_id)}
                            >
                                <button
                                    title={department.name}
                                    className={`flex items-center justify-center w-8 h-8 m-2 rounded-xl hover:bg-white hover:bg-opacity-20 ml-2 `}
                                    style={{ backgroundColor: department.color }}
                                >
                                    <span className="text-white font-bold text-[10px]">{department.name
                                        .split(' ') // Split the name into an array of words
                                        .filter(word => word.toLowerCase() !== 'and')
                                        .map(word => word.charAt(0).toUpperCase()) // Get the first letter of each word
                                        .slice(0, 2) // Take the first two letters
                                        .join('')}
                                    </span>
                                </button>
                                {!collapsed && <span className={`text-[12px]`}>{department.name?.length > 18 ? `${department.name.substring(0, 18)}...` : department.name}</span>}
                            </div>
                            {!collapsed && (department.department_id === activeDepartmentId || hoveredDepartmentId === department.department_id ) && (
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setDepartmentfornotifications(department);
                                        setIsNotificationsPopupOpen(true);
                                        //////console.log('More options clicked for:', department.name);
                                    }}
                                    className="px-2 hover:bg-gray-100 rounded-full"
                                >
                                    <HiOutlineDotsVertical className = "text-gray-500"/>
                                </button>
                            )}
                        </div>
                    ))}
                </nav>
            </div>


            <Popup
                open={isPopupOpen}
                onClose={closeCreation}
                contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '810px', marginTop: '14vh' }}
            >
                <Overlay close={closeCreation} department={currentDepartment} edit={true} />
            </Popup>


            <Popup
                open={isNotificationsPopupOpen}
                onClose={closeNotificationsPopup}
                contentStyle={{ overflow: 'auto', maxHeight: '80vh', width: '810px', marginTop: '14vh' }}
            >
                <NotificationsOverlay close={closeNotificationsPopup} department={departmentfornotifications} />
            </Popup>
        </div>
    );


};


const mapStateToProps = (state) => {
    return {
        profile: state.profile.profile,
        sidebar_collapsed: state.auth.sidebar_collapsed,
        newlycreatedDepartmentId: state.department.newlycreatedDepartmentId,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {

        setSidebarCollapsedFN: (collapsed) =>
            dispatch(setSidebarCollapsed(collapsed)),
        createDepartmentFN: () => dispatch(createDepartment()),
        resetNewlycreatedDepartmentIdFN: () => dispatch(resetNewlycreatedDepartmentId()),
        getDepartmentsFN: () => dispatch(getDepartments()),
    };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
    ITSideBar
);






